import React from 'react';
import annourSatzungPDF from '../../files/Anoor_Verein_Satzung_11092015.pdf';

const AboutMembers = () => {
  const members = [
    {
      function: '1. Vorsitzender',
      title: 'Herr Dr.',
      firstName: 'Abdulghani',
      lastName: 'Albadawi',
    },
    {
      function: 'Stellvertretender Vorsitzender',
      title: 'Herr Dr.',
      firstName: 'Yaser',
      lastName: 'Daaboul',
    },
    {
      function: 'Kassenwart',
      title: 'Herr Dr.',
      firstName: 'M. Yasser',
      lastName: 'Al Nahlaoui',
    },
    {
      function: 'Schriftführer',
      title: 'Herr Dr. med.',
      firstName: 'Ehab',
      lastName: 'Abu-El-Auf',
    },
    {
      function: 'Beisitzer',
      title: 'Herr Dr.',
      firstName: 'Anas',
      lastName: 'Alfarra',
    },
  ];

  return (
    <div className="">
      <h1 className="text-3xl md:text-4xl font-bold text-center text-main mb-2">
        Vorstand Annour e.V.
      </h1>
      <p className="text-center text-gray-600 text-lg mb-8">
        (seit 27.01.2019)
      </p>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-1">
        {members.map((member, index) => (
          <div
            key={index}
            className="border border-gray-200 bg-gray-50 p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <p className="text-main font-semibold text-sm uppercase mb-1">
              {member.function}
            </p>
            <p className="text-lg font-bold text-gray-800">
              {member.title} {member.firstName} {member.lastName}
            </p>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <a
          href={annourSatzungPDF}
          download
          className="text-blue-600 underline text-xl font-semibold hover:text-blue-800"
        >
          Satzung von Annourverein herunterladen
        </a>
      </div>

      <div className="mt-12 bg-gray-100 p-6 rounded-lg text-center shadow-inner">
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          📍 Vereinssitz
        </h2>
        <p className="text-gray-700 leading-relaxed">
          Arabische Schule in Braunschweig Annour e.V.
          <br />
          Petzvalstr. 50
          <br />
          38104 Braunschweig
          <br />
          Deutschland
        </p>
      </div>
    </div>
  );
};

export default AboutMembers;
